import React, { useState, useEffect } from 'react'
import PublishersHeader from '../../components/Header/PublishersHeader'
import publisherprofileStyle from './PublisherProfilePage.module.css'
import { useMediaQuery } from 'react-responsive';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useParams, useNavigate } from "react-router-dom";

export default function PublisherProfilePage() {

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    // Password Eyes
    const [isPasswordVisible, setPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!isPasswordVisible);
    };

    // Confirm Password Eyes
    const [isCPasswordVisible, setCPasswordVisible] = useState(false);

    const toggleCPasswordVisibility = () => {
        setCPasswordVisible(!isCPasswordVisible);
    };

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [fullname, setFullname] = useState('');
    const [imageFile, setImageFile] = useState(null);
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const { id } = useParams();

    useEffect(() => {
        //const userId = 123; // replace with actual logged-in user's ID
        fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_publisher_profile.php?user_id=${id}`)
            .then(res => res.json())
            .then(data => {
                // Fill state with data
                setFirstName(data.first_name);
                setLastName(data.last_name);
                setEmail(data.user_email);
                setPhone(data.user_phone);
                setFullname(data.full_name);
                setPassword(data.password);
                setConfirmPassword(data.password);
                setImagePreviewUrl(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/${data.image_path}`);
            });
    }, []);

    const handleSave = () => {
        if (password !== confirmPassword) {
            alert("Passwords do not match");
            return;
        }

        const userId = id; // Replace with actual user ID from session/context
        const formData = new FormData();

        formData.append('user_id', userId);
        formData.append('firstName', firstName);
        formData.append('lastName', lastName);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('fullname', fullname);
        formData.append('password', password);
        if (imageFile) {
            formData.append('image', imageFile);
        }

        fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/update_publisher_profile.php`, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                alert(data.message);
            });
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setImagePreviewUrl(reader.result);
            reader.readAsDataURL(file);
        }
    };

    return (
        <>
            <PublishersHeader />
            {isMobile ? (
                <div className={publisherprofileStyle.mobilpublisherprofilepage}>
                    <div className="container h-100">
                        <div className="row justify-content-center h-100 align-items-start">
                            <div className="col-xl-12 col-xxl-12">
                                <h3> Publisher Profile </h3>
                                <div className={publisherprofileStyle.mobilpublisherContent}>
                                    <div className="row g-2 mb-3">
                                        <div className='row g-0'>
                                            <div className="col-3">
                                                <div className={publisherprofileStyle.mobilpublisherproimageCircle}>
                                                    <div className={publisherprofileStyle.mobilpublisherprocircleEdit}>
                                                        <input type='file' id="mobilpublisherimageUploads" className={publisherprofileStyle.mobilpulisherproInputcircle} accept=".png, .jpg, .jpeg" />
                                                        <label for="mobilpublisherimageUploads"></label>
                                                    </div>
                                                    <div className={publisherprofileStyle.mobilpublisherprocirclePreview}>
                                                        <div id="publisherimagePreview"> </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <label className={`${publisherprofileStyle.mobilpublisherproLabel} form-label`}> First Name </label>
                                            <input type="text" className={`${publisherprofileStyle.mobilpublisherproInput} form-control`} required />
                                        </div>
                                        <div className="col-6">
                                            <label className={`${publisherprofileStyle.mobilpublisherproLabel} form-label`}> Last Name </label>
                                            <input type="text" className={`${publisherprofileStyle.mobilpublisherproInput} form-control`} required />
                                        </div>
                                        <div className="col-12">
                                            <label className={`${publisherprofileStyle.mobilpublisherproLabel} form-label`}> Name of Publisher </label>
                                            <input type="text" className={`${publisherprofileStyle.mobilpublisherproInput} form-control`} required />
                                        </div>
                                        <div className="col-12">
                                            <label className={`${publisherprofileStyle.mobilpublisherproLabel} form-label`}> Email Address </label>
                                            <input type="email" className={`${publisherprofileStyle.mobilpublisherproInput} form-control`} required />
                                        </div>
                                        <div className="col-12">
                                            <label className={`${publisherprofileStyle.mobilpublisherproLabel} form-label`}> Phone Number </label>
                                            <input type="number" className={`${publisherprofileStyle.mobilpublisherproInput} form-control`} required />
                                        </div>
                                        <div className="col-12 mt-4">
                                            <hr />
                                        </div>
                                        <div className="col-12">
                                            <label className={`${publisherprofileStyle.mobilpublisherproLabel} form-label`}> Username </label>
                                            <input type="text" className={`${publisherprofileStyle.mobilpublisherproInput} form-control`} required />
                                        </div>
                                        <div className="col-12">
                                            <label className={`${publisherprofileStyle.mobilpublisherproLabel} form-label`}> Choose your password </label>
                                            <div className={publisherprofileStyle.publisherpropasswordwrapper}>
                                                <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${publisherprofileStyle.mobilpublisherproInput} form-control`} required />
                                                <div className={publisherprofileStyle.publisherprotogglebutton} onClick={togglePasswordVisibility}>
                                                    {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <label className={`${publisherprofileStyle.mobilpublisherproLabel} form-label`}> Confirm your password </label>
                                            <div className={publisherprofileStyle.publisherpropasswordwrapper}>
                                                <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${publisherprofileStyle.mobilpublisherproInput} form-control`} required />
                                                <div className={publisherprofileStyle.publisherprotogglebutton} onClick={toggleCPasswordVisibility}>
                                                    {isCPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="text-center mb-4">
                                        <button className={`${publisherprofileStyle.mobilpublisherprosaveButton} btn btn-primary w-100`}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={publisherprofileStyle.publisherprofilepage}>
                    <div className="container h-100">
                        <div className="row justify-content-center h-100 align-items-start">
                            <div className="col-xl-9 col-xxl-9">
                                <h3> Account Profile </h3>
                                <div className={publisherprofileStyle.publisherprofileContent}>
                                    <div className="row mb-3 justify-content-center">
                                        <div className="col-xl-9 col-xxl-9">
                                            <h6> Publisher Information </h6>
                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <label className={`${publisherprofileStyle.publisherproLabel} form-label`}>First Name </label>
                                                    <input type="text" className={`${publisherprofileStyle.publisherproInput} form-control`} value={firstName} onChange={e => setFirstName(e.target.value)} required />
                                                </div>
                                                <div className="col-md-6">
                                                    <label className={`${publisherprofileStyle.publisherproLabel} form-label`}>Last Name</label>
                                                    <input type="text" className={`${publisherprofileStyle.publisherproInput} form-control`} value={lastName} onChange={e => setLastName(e.target.value)} required />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <label className={`${publisherprofileStyle.publisherproLabel} form-label`}>Name of Publisher</label>
                                                    <input type="text" className={`${publisherprofileStyle.publisherproInput} form-control`} value={fullname} onChange={e => setEmail(e.target.value)} required />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <label className={`${publisherprofileStyle.publisherproLabel} form-label`}>Email Address</label>
                                                    <input type="email" className={`${publisherprofileStyle.publisherproInput} form-control`} value={email} onChange={e => setEmail(e.target.value)} required />
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <label className={`${publisherprofileStyle.publisherproLabel} form-label`}>Phone:</label>
                                                    <input type="number" className={`${publisherprofileStyle.publisherproInput} form-control`} value={phone} onChange={e => setPhone(e.target.value)} required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-xxl-3">
                                            <div className={publisherprofileStyle.publisherproimageCircle}>
                                                <div className={publisherprofileStyle.publisherprocircleEdit}>
                                                    <input type='file' id="publisherimageUploads" className={publisherprofileStyle.pulisherproInputcircle} accept=".png, .jpg, .jpeg" onChange={handleImageChange} />
                                                    <label for="publisherimageUploads"></label>
                                                </div>
                                                <div className={publisherprofileStyle.publisherprocirclePreview}>
                                                    <div id="publisherimagePreview">
                                                        {imagePreviewUrl && <img src={imagePreviewUrl} alt="preview" style={{ width: '100%', height: '100%', borderRadius: '50%' }} />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-xl-9 col-xxl-9">
                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <label className={`${publisherprofileStyle.publisherproLabel} form-label`}>Username</label>
                                                    <input type="text" className={`${publisherprofileStyle.publisherproInput} form-control`} value={email} onChange={e => setEmail(e.target.value)} required />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="mb-3">
                                                    <label className={`${publisherprofileStyle.publisherproLabel} form-label`}> Choose your password </label>
                                                    <div className={publisherprofileStyle.publisherpropasswordwrapper}>
                                                        <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${publisherprofileStyle.publisherproInput} form-control`} value={password}
                                                            onChange={e => setPassword(e.target.value)} required />
                                                        <div className={publisherprofileStyle.publisherprotogglebutton} onClick={togglePasswordVisibility}>
                                                            {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="mb-3">
                                                    <label className={`${publisherprofileStyle.publisherproLabel} form-label`}> Confirm your password </label>
                                                    <div className={publisherprofileStyle.publisherpropasswordwrapper}>
                                                        <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${publisherprofileStyle.publisherproInput} form-control`} value={confirmPassword}
                                                            onChange={e => setConfirmPassword(e.target.value)} required />
                                                        <div className={publisherprofileStyle.publisherprotogglebutton} onClick={toggleCPasswordVisibility}>
                                                            {isCPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-xxl-3"></div>
                                    </div>
                                    <div className="row">
                                        <div className="text-center mb-3 mt-4">
                                            <button className={`${publisherprofileStyle.publisherprosaveButton} btn btn-warning `} onClick={handleSave}>Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
